import { render, staticRenderFns } from "./NewsListPanel.vue?vue&type=template&id=5c61c34a&"
import script from "./NewsListPanel.vue?vue&type=script&lang=ts&"
export * from "./NewsListPanel.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports